









import { Component, Vue, Emit } from "vue-property-decorator";
@Component
export default class AddSmartGuideHeaderButton extends Vue {
  @Emit()
  clicked() {
    return true;
  }
}
